__turbopack_context__.v({
  "accordion": "_8lwbDG_accordion",
  "chevron": "_8lwbDG_chevron",
  "collapsed": "_8lwbDG_collapsed",
  "contentContainer": "_8lwbDG_contentContainer",
  "expanded": "_8lwbDG_expanded",
  "groupAction": "_8lwbDG_groupAction",
  "headerAndChevron": "_8lwbDG_headerAndChevron",
  "item": "_8lwbDG_item",
  "transition": "_8lwbDG_transition",
});
